import React, { Fragment, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import date from 'date-and-time';

import BotoneraBottom from '../Compartidos/BotoneraBottom';
import HeaderEjercicios from '../../AuxiliaresPaginas/HeaderEjercicios';
import Instrucciones from '../../Escritorio/Instrucciones';
import useConfigAuth from '../../../Hooks/useConfigAuth';

import { finalizarEjercicioAction, setearEjercicioAction } from '../../../actions/estadoEjercicioActions';
import { almacenarAction } from '../../../actions/almacenarEjercicioActions';

// css
import { ContainerFlex } from '../../Css/MetodosCSS/StyledLN2Todos';
import { Img } from '../../Css/StyledForm';
import { Circulo, Cuadrado} from '../../Css/MetodosCSS/StyledFonemica';
import {Flex} from '../../Css/MetodosCSS/StyledCCIntrasilabica';
import { BtnColor } from '../../Css/MetodosCSS/StyledLectoEscritura';

const instrucciones = 'Vamos a ver un dibujo en la pantalla y vamos a jugar a cambiar un sonido por otro para formar una nueva palabra';
const miniInstrucciones = '';

const SCR6 = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [config] = useConfigAuth();

    const [count, setCount] = useState(1);
    const [disable, setDisable] = useState(false);
    const [comparar, setComparar] = useState([]);
    const [circulos, setCirculos] = useState([]);
    const [contarTiempo, setContarTiempo] = useState([]);
    const [ultimoTiempo, setUltimoTiempo] = useState(false);
    const [indexes, setIndexes] = useState([]);
    const [resultado, setResultado] = useState([]);
    const [ayuVisual, setAyuVisual] = useState(false);
    const [ayuVisualSolicitada, setAyuVisualSolicitada] = useState(false);

    const iniciar = useSelector(state => state.ejercicio.iniciar);
    const finalizar = useSelector(state => state.ejercicio.finalizar);
    const id_paciente = useSelector((state) => state.usuario.id_paciente);

    const informacion = useSelector(state => state.informacion.info_DB);

    const resultadoBase = [
        {palabra_correcta:"", puntaje:"", ayuda:"", ejemplo:""},
        {palabra_correcta:"", puntaje:"", ayuda:"", ejemplo:""},
        {palabra_correcta:"", puntaje:"", ayuda:"", ejemplo:""},
        {palabra_correcta:"", puntaje:"", ayuda:"", ejemplo:""},
        {palabra_correcta:"", puntaje:"", ayuda:"", ejemplo:""},
        {palabra_correcta:"", puntaje:"", ayuda:"", ejemplo:""},
        {palabra_correcta:"", puntaje:"", ayuda:"", ejemplo:""},
        {palabra_correcta:"", puntaje:"", ayuda:"", ejemplo:""},
        {palabra_correcta:"", puntaje:"", ayuda:"", ejemplo:""},
        {palabra_correcta:"", puntaje:"", ayuda:"", ejemplo:""},
        {palabra_correcta:"", puntaje:"", ayuda:"", ejemplo:""},
        {palabra_correcta:"", puntaje:"", ayuda:"", ejemplo:""},
        {palabra_correcta:"", puntaje:"", ayuda:"", ejemplo:""}
    ];

    const setearAyuVisual = (e) => {
        e.preventDefault();
        if (ayuVisual) {
            setAyuVisual(false);
        } else {
            setAyuVisual(true);
        }
        if(ayuVisualSolicitada){
            return;
        } else {
            setAyuVisualSolicitada(true);
        }
    }

    const verifico = (e, nro) => {
        e.preventDefault();
        if(comparar.ejemplo == 1) {
            const newList = JSON.parse(JSON.stringify(resultado));
            newList[count-1].palabra_correcta = comparar.imagen_url_1;
            newList[count-1].puntaje = 0;
            newList[count-1].ayuda = false;
            newList[count-1].ejemplo = 1;
            setResultado(newList);
            if(count < indexes) {
                setTimeout(() => {
                    setDisable(false);
                    setCount(count + 1);
                }, 100);
            } else {
                setUltimoTiempo(true);
                setTimeout(() => {
                    setDisable(false);
                    dispatch( finalizarEjercicioAction() )
                }, 100);
            }
            return
        }
        setDisable(true);
        const newList = JSON.parse(JSON.stringify(resultado));
        newList[count-1].palabra_correcta = comparar.imagen_url_1;
        let primero;
        let ayuda;
        if(nro == 2){
            primero = 2;
        } else {
            primero = 0;
        }
        if(ayuVisualSolicitada){
            ayuda = 1;
        } else {
            ayuda = 0;
        }
        let puntajeParcial;
        if(primero == 0) {
            puntajeParcial = 0
        } else {
            puntajeParcial = primero - ayuda;
        }
        newList[count-1].puntaje = puntajeParcial;
        newList[count-1].ayuda = ayuda;
        newList[count-1].ejemplo = 0;
        setResultado(newList);
        if(count < indexes) {
            setTimeout(() => {
                setDisable(false);
                setCount(count + 1);
            }, 100);
        } else {
            setUltimoTiempo(true);
            setTimeout(() => {
                setDisable(false);
                dispatch( finalizarEjercicioAction() )
            }, 100);
        }
    }
    
    useEffect(() => {
        dispatch(setearEjercicioAction('SCR6') );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        setComparar(informacion[count-1]);
        setIndexes(Object.keys(informacion).length);
        setAyuVisual(false);
        setAyuVisualSolicitada(false);
        const cantidad = informacion[count-1]?.cantidad_silabas;
        const newArray = Array.from({ length: cantidad }, (_, index) => ({ id: index + 1 }));
        setCirculos(newArray);
    }, [count, informacion])
    
    useEffect(() => {
        setResultado(resultadoBase);
    }, [informacion])

    useEffect(() => {
        if(iniciar === false && count === indexes){
            return;
        }else if(iniciar === false && count === 1){
            return;
        } else {
            const newList = JSON.parse(JSON.stringify(contarTiempo));
            newList.push(new Date());
            setContarTiempo(newList);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [iniciar,count, ultimoTiempo]);

    useEffect(() => {
        if(finalizar){
            const tiempo = JSON.parse(JSON.stringify(contarTiempo));
            const conseguirTiempos = (a) => {
                const t = [];
                for (let i = 0; i < a.length - 1; i++){
                    const despues = new Date(a[i+1]);
                    const antes = new Date(a[i])
                    const segundos = Math.round((date.subtract(despues, antes).toSeconds())*10)/10;
                    t.push(segundos);
                }
                return t
            }
            const tiempoFinal = conseguirTiempos(tiempo);

            const informacion = {
                config,
                payload: {
                    'screening': true,
                    'tiempo': tiempoFinal,
                    'ejercicio': "SCR6",
                    'resultado': resultado,
                    'id_paciente': id_paciente
                }
            }
            dispatch( almacenarAction(informacion) );
            navigate("/escritorio/metodos/finalizar-ejercicio");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [finalizar]);

    return (
        <Fragment>
            <HeaderEjercicios estrellas={true} carrito={true} minMay={false} ayuImagen={false} />
            {iniciar
                ?
                <ContainerFlex display="flex" direction="column" height="100%" width="100%">
                    {comparar.ejemplo ? 
                    <Flex margin="1rem 0 0 2rem" style={{fontSize:"40px", fontFamily:"Nunito", fontWeight:"bold", justifyContent:"start" }}>
                        Ejemplo
                    </Flex>
                    : null
                    }
                        <ContainerFlex position='fixed' right='0' top='0' margin='5.5rem 2rem 0 0'>
                            <ContainerFlex height="5vh" margin='0 0 0 0.3rem'>
                                <BtnColor bg="transparent" border="none"
                                    onClick={(e) => setearAyuVisual(e)}
                                >   
                                    {ayuVisual ? 
                                    <Img width="45px" src={`/img/ayuda_clickeado.png`} />
                                    :
                                    <Img width="45px" src={`/img/icono_ayuda.png`} />
                                    }
                                    
                                </BtnColor>
                            </ContainerFlex>
                        </ContainerFlex>
                        <ContainerFlex display="flex" align="center" justify="center" margin="auto" direction="column">
                        <ContainerFlex>
                            <Img align="center" justify="center" src={`/img/${comparar.imagen_url_1}.png`} width="30vw" widthmob="30vw" />
                        </ContainerFlex>
                        {ayuVisual ? 
                        <ContainerFlex display="flex" margin="0.5rem 0 0 0">
                            {circulos.map(obj => (
                                <div
                                    key={obj.id}
                                >
                                    <Circulo></Circulo> 
                                </div>
                            ))}
                        </ContainerFlex>
                        : null 
                        }
                    </ContainerFlex>

                    <ContainerFlex display="flex" justify="space-between" justifyself="end" margin="0 0 0.5rem 0">
                        <ContainerFlex>
                            <BotoneraBottom miniInstrucciones={miniInstrucciones} />
                        </ContainerFlex>
                        <ContainerFlex display="flex">
                            <ContainerFlex display="flex" margin ="0 1rem 0 0">
                                <Cuadrado backgroundColor="#646464" margin="0 0.3rem 0 0"
                                disabled={disable}
                                onClick={(e) => verifico(e, 1)}
                                ></Cuadrado>
                                <Cuadrado backgroundColor="#5DEBC9"
                                disabled={disable}
                                onClick={(e) => verifico(e, 2)}
                                ></Cuadrado>
                            </ContainerFlex>
                        </ContainerFlex>
                    </ContainerFlex>
                </ContainerFlex>
                :
                <Instrucciones instrucciones={instrucciones} />
            }
        </Fragment>
    );
}
 
export default SCR6;